@if (showNavbar) {
  <navbar></navbar>
}

<router-outlet></router-outlet>
